export const handleIntegerInput = callback => event => {
    const parsedValue = parseInt(event.target.value.replaceAll(',', ''), 10);
    if (!parsedValue) {
        event.target.value = '';
    }
    callback(!isNaN(parsedValue) ? Math.abs(parsedValue) : null);
};
